/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

/**
 * Styled components for laying out sections of a page
 */

import React, { forwardRef } from "react";

import styled from "styled-components";

interface ContentContainerProps {
  children: React.ReactNode;
}

/**
 * Children of ScrollContainer scroll like normal. Parents & Siblings (like AppTopbar)
 * are fixed and don't scroll with the page. @later the any type on the ref is annoying but needed to make it "optional"
 */
export const ScrollContainer = forwardRef<any, ContentContainerProps>(({ children }, ref) => {
  return (
    <StyledContentScrollContainer ref={ref}>
      <StyledContentContainer>{children}</StyledContentContainer>
    </StyledContentScrollContainer>
  );
});

export const AppWrapper = styled.div`
  display: flex;
  flex-direction: column; // put AppTopbar and the View component in a column flex
  // hide overflow and set width to screen height. scrolling will be handled by a div below the topbar
  height: 100vh; // dvh breaks safari & in vh Chrome, Firefox & Safari work fine. overidden to unset if mobile
  /* overflow: hidden; */
  @media print {
    height: auto !important;
    overflow: visible !important;
  }
`;

const StyledContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100%;
  position: relative;
  user-select: none;
`;

const StyledContentScrollContainer = styled.div`
  height: 100%;
  overflow-y: scroll;
  user-select: none;
  -webkit-user-select: none;
`;

// this element should not be positioned. It will mess up the context menu position.
export const PageWrapper = styled.div`
  overflow-y: hidden;
  overflow-x: hidden;
  flex-grow: 1;
`;
